import { useEffect, useState } from "react";
import "./MindMappingReportBThirdSection.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const MindMappingReportBThirdSection = ({ res,toggle}) => {
  const [selectedSectorType, setSelectedSectorType] = useState("tertiary");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    if (res?.sector_type) {
      // Standardize to lowercase to match mapping keys
      setSelectedSectorType(res.sector_type.toLowerCase());
    }
  }, [res]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Data Mapping from the "Sector Type vs Startup & Investor Perspective" image
  const sectorMapping = {
    primary: {
      covers: "Agriculture, Mining, Fisheries, Natural resources",
      advantages: "Real-world demand, essential goods, govt support",
      disadvantages: "Low margins, weather & supply risk, slow scaling",
      accessibility: "⭐⭐ Low—Medium",
      investor: "⚠️ Selective (Impact, Govt, ESG funds)",
      bestFit: "AgriTech, Food supply chains, Rural tech"
    },
    secondary: {
      covers: "Manufacturing, Processing, Industrial production",
      advantages: "Tangible assets, export potential, job creation",
      disadvantages: "Capital intensive, longer ROI cycles",
      accessibility: "⭐⭐⭐ Medium",
      investor: "🎯 Strategic & PE interest",
      bestFit: "Manufacturing, EV, Hardware, Industrial Tech"
    },
    tertiary: {
      covers: "Services, IT, SaaS, Platforms, Consulting",
      advantages: "High scalability, asset-light, fast growth",
      disadvantages: "High competition, valuation volatility",
      accessibility: "⭐⭐⭐\n⭐⭐ \n Very High",
      investor: "🏆 Highly preferred by VCs",
      bestFit: "SaaS, FinTech, EdTech, Marketplaces"
    }
  };

  // Default to tertiary if the sector_type doesn't match
  const activeData = sectorMapping[selectedSectorType] || sectorMapping["tertiary"];

  return (
    <div className="mind-mapping-report-b-third-container">
      <div className={toggle?"table-adjust":"mind-mapping-report-b-third-final-table"}> 
        {/* Decorative Corners */}
        <span className="mind-mapping-report-b-third-corner mind-mapping-report-b-third-corner-top-left"></span>
        <span className="mind-mapping-report-b-third-corner mind-mapping-report-b-third-corner-top-right"></span>
        <span className="mind-mapping-report-b-third-corner mind-mapping-report-b-third-corner-bottom-left"></span>
        <span className="mind-mapping-report-b-third-corner mind-mapping-report-b-third-corner-bottom-right"></span>

        <div className="mind-mapping-report-b-third-module-title">
           <span className="module-prefix">Module 3:</span> Sector Type vs Startup & Investor Perspective
        </div>
        <QTag
          q="What is the primary sector type of your startup idea?"
          a={`${selectedSectorType.charAt(0).toUpperCase() + selectedSectorType.slice(1)} — ${activeData.covers}`}
          impacts="Funding access, competition density, scalability ceiling, and investor preference"
        />
        <div className="mind-mapping-report-b-third-table-scroll-wrapper">
          <table className="mind-mapping-report-b-third-inner-table">
            <thead>
              <tr>
                <th className="mind-mapping-report-b-third-col-sno">S.NO</th>
                <th>Sector Type</th>
                <th>What It Covers</th>
                <th>Key Advantages</th>
                <th>Key Disadvantages</th>
                <th>Accessibility to Start</th>
                <th>Investor Preference</th>
                <th>Best-Fit Startup Types</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mind-mapping-report-b-third-col-sno">3 A</td>
                <td className="mind-mapping-report-b-third-user-val">
                  {selectedSectorType.charAt(0).toUpperCase() + selectedSectorType.slice(1)}
                </td>
                <td>{activeData.covers}</td>
                <td>{activeData.advantages}</td>
                <td>{activeData.disadvantages}</td>
                <td>
                  {isMobile ? (
                    activeData.accessibility.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        {index < activeData.accessibility.split('\n').length - 1 && <br />}
                      </span>
                    ))
                  ) : (
                    activeData.accessibility
                  )}
                </td>
                <td>{activeData.investor}</td>
                <td className="mind-mapping-report-b-third-highlight">
                  {activeData.bestFit}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportBThirdSection;